export enum Permission {
  PartnerManagementView = 'partner_management.view',
}
